import { render, staticRenderFns } from "./BarTableChart.vue?vue&type=template&id=b8ff4b04&"
import script from "./BarTableChart.vue?vue&type=script&lang=js&"
export * from "./BarTableChart.vue?vue&type=script&lang=js&"
import style0 from "./BarTableChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports